"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _functionTree = require("function-tree");
var _cerebral = require("cerebral");
var _translate = _interopRequireDefault(require("./translate"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function TranslateProvider() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    service = _ref.service;
  return service ? new _functionTree.Provider(_translate.default) : (0, _cerebral.Provider)(_translate.default);
}
var _default = TranslateProvider;
exports.default = _default;
//# sourceMappingURL=index.js.map